<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex'
import sendLog from '@/utils/q_log'
// eslint-disable-next-line
import { openScheme, getQueryString, RouterHelper, getFromForLog } from '@/utils/q_business'
import { Sniff } from '@/utils/q_sniff'
import { loginQ } from '@/utils/q_userinfo'
import { QShare } from '@/components/sharePopup'
import qunarRedirect from '@/utils/qunarRedirect'
import { queryRedPacketStatus } from '@/services/q_redpack'

export default {
  mixins: [qunarRedirect],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    ...mapState(['houseFilter'])
  },
  watch: {
    payLoad(newVal) {
      if (newVal.type === 'share') {
        // 此处不建议依赖全局的登录
        if (this.$root.isForceLogin && !Sniff.isLogin()) {
          loginQ()
        } else {
          QShare()
        }
        return
      }
      if (newVal) {
        this.doRedirect(newVal)
      }
    }
  },
  mounted() {
    this.showHandle()
  },
  methods: {
    replaceQueryParam(url, param, newValue) {
      // 正则表达式匹配URL中的查询参数
      const re = new RegExp(`([?&])${param}=.*?(&|$)`, 'i')
      // 替换参数值
      return url.replace(re, `$1${param}=${newValue}$2`)
    },
    doRedirect(props) {
      const query = this.$route.query
      const isLinkHouseList = this.compProps.mate.isLinkHouseList
      const logParam = {
        actPos: `${this.compIndex}_${props.imgIndex}`,
        actPage: `cms_${this.$root.promotionId}`,
        actText: `cms_${this.$root.promotionId}_imageComp`
      }
      sendLog(logParam)
      const newCityId = this.houseFilter.cityId || query.cityId
      if (isLinkHouseList && newCityId && props.type === 'list') {
        const needVal = {
          mpLink: props.mpLink,
          appLink: props.appLink,
          activeLink: props.activeLink
        }
        // m站
        if (needVal.activeLink) {
          try {
            // https://m.tujia.com/hotel_beijing/
            // https://m.tujia.com/hotel_beijing/6-1235/
            // https://m.tujia.com/hotel_beijing_5-5_5276/6-1235/
            // => 转换成 https://m.tujia.com/hotel_city${cityId}/
            // 思路找到 二级 path, 然后按照 _ 分割, 替换第二个为city${cityId}
            const url = new URL(needVal.activeLink)
            const pathArr = url.pathname.split('/')
            const cityStr = pathArr[1].split('_')
            cityStr[1] = `city${newCityId}`
            pathArr[1] = cityStr.join('_')
            url.pathname = pathArr.join('/')
            needVal.activeLink = url.href
          } catch (e) {
          }
        }
        // 处理小程序
        if (needVal.mpLink) {
          needVal.mpLink = this.replaceQueryParam(needVal.mpLink, 'cityId', newCityId)
        }
        // 处理 q app
        // react/open?hybridId=bnbrn&pageName=SearchList&initProps=%7B%22param%22%3A%7B%22id%22%3A63%7D%7D
        if (needVal.appLink) {
          try {
            const initProps = JSON.parse(getQueryString('initProps', needVal.appLink))
            initProps.param.id = newCityId
            needVal.appLink = this.replaceQueryParam(needVal.appLink, 'initProps', encodeURIComponent(JSON.stringify(initProps)))
          } catch (err) {
          }
        }
        this.redirectTo(needVal)
        return
      }
      if (props.appLink && Sniff.isRN) {
        if (props.type === 'article') {
          openScheme(props.appLink, 'navibar-normal')
          return
        }
        // const { scheme } = Sniff
        // let crnUrl = scheme + '://' + props.appLink
        // // 补上channelId
        // // react/open?hybridId=bnbrn&pageName=SearchList&initProps=%7B%22param%22%3A%7B%22id%22%3A48%2C%22url%22%3A%22https%3A%2F%2Fm.tujia.com%2Fgongyu%2Fbeijing%2F%3FcityId%3D48%26cds%3D6_4168__5_12_10609%22%7D%7D
        // try {
        //   const rnParams = crnUrl.split('initProps=')
        //   if (rnParams && rnParams[1]) {
        //     let rnProps = JSON.parse(decodeURIComponent(rnParams[1]))
        //     if (rnProps.channelId === undefined) {
        //       rnProps.channelId = this.$route.query.code || `cms_${this.$root.promotionId}`
        //     }
        //     rnProps = JSON.stringify(rnProps)
        //     crnUrl = `${rnParams[0]}initProps=${encodeURIComponent(rnProps)}`
        //   }
        // } catch (e) {
        // }
        // window.hysdk.schemeForResult({
        //   scheme: crnUrl
        // })
        // return
      }
      // if (props.activeLink) {
      //   const url = props.activeLink
      //   const title = getQueryString('title', url)
      //   openScheme(url, 'navibar-normal', title)
      // }
      this.redirectTo(props)
    },
    async showHandle() {
      try {
        const items = this.compProps?.mate?.items || []
        for (const item of items) {
          if (item && item.showType === 1) { // 红包判断条件
            const activityIdList = item?.activeId?.split(',') || []
            const res = await queryRedPacketStatus(activityIdList)
            const ret = res?.value || {}
            if (ret && ret.errcode === 0 && ret.data) {
              const canShow = ret.data.redpacketActivities ? ret.data.redpacketActivities.every((item) => {
                // 已领取，未使用，才展示
                return item.receive && !item.used
              }) : false
              this.$set(item, 'show', canShow)
            } else {
              this.$set(item, 'show', false)
              ret.errmsg && this.$toast(ret.errmsg)
            }
          } else {
            this.$set(item, 'show', true)
          }
        }
        this.$emit('init', this.compProps.mate)
      } catch (err) {}
    }
  }
}
</script>
